import { render, staticRenderFns } from "./UpdatePasien.vue?vue&type=template&id=dba90d3c"
import script from "./UpdatePasien.vue?vue&type=script&lang=js"
export * from "./UpdatePasien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dba90d3c')) {
      api.createRecord('dba90d3c', component.options)
    } else {
      api.reload('dba90d3c', component.options)
    }
    module.hot.accept("./UpdatePasien.vue?vue&type=template&id=dba90d3c", function () {
      api.rerender('dba90d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/UpdatePasien.vue"
export default component.exports